import {useState} from 'react'
import DeleteConfirmModal from '../common/DeleteConfirmModal'
import {TemplateRow} from 'models/CreatePromotion'
import DeleteIcon from '../../../img/deleteIcon.svg'
import EditIcon from '../../../img/editIcon.svg'
import {useTranslation} from 'react-i18next'
import AttentionModal from '../common/AttentionModal'

type Props = {
 templates: TemplateRow[]
 setEditRow: (row: TemplateRow | null) => void
 setShowDialog: (value: boolean) => void
 handleDelete: (id: number) => void
}

const TableTemplate = ({
 templates,
 setEditRow,
 setShowDialog,
 handleDelete,
}: Props) => {
 const {t} = useTranslation()
 const [showDelete, setShowDelete] = useState(false)
 const [showModal, setShowModal] = useState(false)
 const [itemToDelete, setItemToDelete] = useState<
  number | null
 >(null)
 return (
  <div className='mt-6 border border-[#D9DDE3] overflow-hidden bg-white'>
   <div className='overflow-x-auto'>
    <table className='w-full text-sm border-collapse table-fixed'>
     <colgroup>
      <col className='w-[18%]' />
      <col className='w-[22%]' />
      <col className='w-[45%]' />
      <col className='w-[15%]' />
     </colgroup>

     <thead>
      <tr className='bg-[#8B8F94] text-white'>
       <td className='p-4 text-left border-r border-[#BFC4CA] break-words whitespace-normal leading-snug'>
        {t('createPromotion.templateTable.language')}
       </td>
       <td className='p-4 text-left border-r border-[#BFC4CA] break-words whitespace-normal leading-snug'>
        {t('createPromotion.templateTable.templateName')}
       </td>
       <td className='p-4 text-left border-r border-[#BFC4CA] break-words whitespace-normal leading-snug'>
        {t('createPromotion.templateTable.templateText')}
       </td>
       <th className='p-4 text-center  break-words whitespace-normal leading-snug'>
        {' '}
        {t('createPromotion.templateTable.action')}
       </th>
      </tr>
     </thead>
     <tbody>
      {templates.map((item) => (
       <tr
        key={item.id}
        className='border-t border-[#E3E6EA] align-top'
       >
        <td className='p-4 border-r border-[#E3E6EA] break-words whitespace-normal'>
         {item.lang?.language}
        </td>
        <td className='p-4 border-r border-[#E3E6EA] break-words whitespace-normal'>
         {item.template_name}
        </td>
        <td
         className='p-4 border-r border-[#E3E6EA]
        whitespace-pre-wrap break-words leading-6 text-[#2F2F2F]
        max-w-[420px]'
        >
         {item.template_text}
        </td>
        <td className='p-4'>
         <div className='flex flex-wrap items-center justify-center gap-6'>
          <button
           onClick={() => {
            if (item.id == null) return
            setItemToDelete(item.id)
            if (templates.length <= 1) setShowModal(true)
            else setShowDelete(true)
           }}
           className='flex items-center gap-1 text-red-600 font-medium'
          >
           <img
            src={DeleteIcon}
            alt='close'
            className='h-4 w-4'
           />
           {t('createPromotion.templateTable.remove')}
          </button>

          <button
           onClick={() => {
            setEditRow(item)
            setShowDialog(true)
           }}
           className='flex items-center gap-1 text-blue-600 font-medium'
          >
           <img
            src={EditIcon}
            alt='close'
            className='h-4 w-4'
           />
           {t('createPromotion.templateTable.edit')}
          </button>
         </div>
        </td>
       </tr>
      ))}
     </tbody>
    </table>
   </div>

   <div
    onClick={() => {
     setEditRow(null)
     setShowDialog(true)
    }}
    className='px-4 py-3 text-blue-600 cursor-pointer bg-[#F8FAFC] border-t border-[#E3E6EA]'
    style={{fontSize: 12}}
   >
    + {t('createPromotion.templateTable.addTemplate')}
   </div>
   {showDelete && (
    <DeleteConfirmModal
     onConfirm={() => {
      setShowDelete(false)
      if (itemToDelete == null) return
      handleDelete(itemToDelete)
     }}
     onCancel={() => setShowDelete(false)}
     title={t('modalData.deleteMessageTitle')}
     description={t('modalData.deleteMessage')}
    />
   )}

   <AttentionModal
    open={showModal}
    onClose={() => setShowModal(false)}
   />
  </div>
 )
}

export default TableTemplate
